import { render, staticRenderFns } from "./ColumnParentTranslatedName.vue?vue&type=template&id=6f6a26b8"
import script from "./ColumnParentTranslatedName.vue?vue&type=script&lang=js"
export * from "./ColumnParentTranslatedName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports